// @flow

import React from "react";
import { localize } from "redux-i18n";
import classNames from "classnames";
import { v4 as uuid } from "uuid";
import { Button, ComboBox, View, Text } from "@components";
import type { OptionType } from "@components";
import type { AbsenceReason } from "@modules/service/reducer/dynamic-questions/types";

type PartialReasonSpecificUsage = $Exact<{
  _id: string,
  id?: number,
  absenceReason?: Object,
}>;

type OwnProps = $Exact<{
  onRef?: (ref: *) => void,
  data: ?Array<AbsenceReason>,
  schema: Object,
  reasons: Array<AbsenceReason>,
  onChange: (data: Array<AbsenceReason>) => void,
  onSubmit: (data: Array<AbsenceReason>) => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class ReasonSpecificUsageForm extends React.Component<Props> {
  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
  }

  get data() {
    if (!this.props.data) {
      return [];
    }

    return (this.props.data || []).map(el => {
      const selectedOption = this.props.reasons.find(reason => reason.id === el.id);
      return {
        value: selectedOption?.id || el.id,
        label: selectedOption?.label || el.label,
      };
    });
  }

  get reasons() {
    if (!this.props.reasons) {
      return [];
    }

    const options = this.props.reasons.map(r => ({ value: r.id, label: r.label }));
    return [...this.inactiveItems, ...options];
  }

  submit() {
    const formattedData = this.data.map(el => ({
      id: el.value,
    }));
    this.props.onSubmit(formattedData);
  }

  handleChange = (val: number[]) => {
    const inactiveData = (this.props.data || []).filter(el => !el.isActive);

    const dataToUpdate = val.map(el => {
      const opt = [...inactiveData, ...this.props.reasons].find(opt => opt.id === el) || {};
      return opt;
    });
    this.props.onChange(dataToUpdate);
  };

  get inactiveItems() {
    return (this.props.data || [])
      .filter(el => el.isActive === false && this.data.find(reason => reason.value === el.id))
      .map(el => ({
        value: el.id,
        label: el.label,
        warning: this.props.t("INACTIVE_REASON_LABEL"),
      }));
  }

  render() {
    return (
      <View margin="2rem 0" alignItems="center">
        <>
          {!!this.inactiveItems.length && (
            <Text color="negative" lineHeight={5}>
              {this.props.t("INACITIVE_REASONS_WARNING")}
            </Text>
          )}
          <ComboBox
            value={this.data}
            options={this.reasons}
            onChange={this.handleChange}
            className="w-100"
            isMulti
          />
        </>
      </View>
    );
  }
}

export default localize()(ReasonSpecificUsageForm);
